export default {
  'contact-mail': 'blog@pixartprinting.com',
  'business-name': 'Pixartprinting S.p.A. enligt en enda medlem',
  'privacy-policy': 'Integritetspolicy',
}
